import { render, staticRenderFns } from "./PreviewKeywords.vue?vue&type=template&id=780fe9d0&scoped=true&"
import script from "./PreviewKeywords.vue?vue&type=script&lang=js&"
export * from "./PreviewKeywords.vue?vue&type=script&lang=js&"
import style0 from "./PreviewKeywords.vue?vue&type=style&index=0&id=780fe9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780fe9d0",
  null
  
)

export default component.exports